export default __webpack_public_path__ + "static/media/nagy_illu.b4caabc4.svg";